import React from "react";

import { useIntl, FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useTheme } from "styled-components";

import Button from "ds/Button";
import { selectCurrentUserUsername } from "Reducers/app/selectors";
import Illustration from "Vendor_resources/images/empty-profiling.svg";
import IllustrationDark from "Vendor_resources/images/empty-profiling_dark.svg";

import * as S from "./Errors.styles";

type GenericErrorProps = {
  error: unknown;
  messageId?: string;
  defaultHeader?: boolean;
};

const GenericError = ({
  error,
  defaultHeader = true,
  messageId
}: GenericErrorProps) => {
  // TODO Discuss with Observability on
  // Making metrics error user friendly
  // At the moment, metrics fails without
  // any response body other than http status code
  // then lets decide if it will be usefull to display
  // the message to the customer
  error;

  const intl = useIntl();
  const theme = useTheme();
  const username = useSelector(selectCurrentUserUsername);

  return (
    <>
      {defaultHeader && (
        <S.H2 tag="h2">
          <FormattedMessage id="metrics" />
        </S.H2>
      )}
      <S.Layout>
        <S.Illustration>
          <img
            src={theme.name === "dark" ? IllustrationDark : Illustration}
            alt={intl.formatMessage({ id: "metrics.error.generic.header" })}
          />
        </S.Illustration>

        <S.H3 tag="h3">
          <FormattedMessage id="metrics.error.generic.header" />
        </S.H3>
        <S.Paragraph>
          <FormattedMessage
            id={messageId || "metrics.error.generic.paragraph"}
          />
        </S.Paragraph>
        <FormattedMessage
          id="metrics.error.generic.link"
          values={{
            a: (...chunks) => (
              <Button
                analyticId="tickets_open"
                variant="link"
                target="_blank"
                to={`/-/users/${username}/tickets/open`}
              >
                {chunks}
              </Button>
            )
          }}
        />
      </S.Layout>
    </>
  );
};

export default GenericError;
